import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/class-control"

const badgeVariants = cva(
  "inline-flex items-center justify-center rounded-full px-3 py-1 text-xs font-medium",
  {
    variants: {
      status: {
        "Em Desenvolvimento": "bg-[#F2C71E]/10 text-[#F2C71E] border border-[#F2C71E]/20",
        "Ativo": "bg-[#13D480]/10 text-[#13D480] border border-[#13D480]/20",
        "Concluído": "bg-[#2078D7]/10 text-[#2078D7] border border-[#2078D7]/20",
        "Cancelado": "bg-[#B9361C]/10 text-[#B9361C] border border-[#B9361C]/20",
      },
    },
    defaultVariants: {
      status: "Em Desenvolvimento",
    },
  }
)

export interface ProjectStatusBadgeProps
  extends VariantProps<typeof badgeVariants> {
  className?: string
}

export function ProjectStatusBadge({ status, className }: ProjectStatusBadgeProps) {
  return (
    <span className={cn(badgeVariants({ status }), className)}>
      {status}
    </span>
  )
}
